var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 32H0V64v96 32H64V160 96h64 32V32H128 32zM64 352V320H0v32 96 32H32h96 32V416H128 64V352zM320 32H288V96h32 64v64 32h64V160 64 32H416 320zM448 352V320H384v32 64H320 288v64h32 96 32V448 352z"}));
}

Expand.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = Expand;

Expand.default = Expand;
